/* eslint-disable */
import React, { useState, useEffect } from "react";
import {
  Card,
  CardHeader,
  CardContent,
  Grid,
  TextField,
  MenuItem,
  Button,
  Typography,
  Box,
  CircularProgress,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  TableContainer,
  Paper,
  Chip,
  FormControlLabel,
  Checkbox,
  RadioGroup,
  Radio,
  FormControl,
  FormLabel,
  Tooltip,
  IconButton,
  InputAdornment
} from "@material-ui/core";
import { makeStyles } from "@material-ui/core/styles";
import SearchIcon from "@material-ui/icons/Search";
import RefreshIcon from "@material-ui/icons/Refresh";
import PrintIcon from "@material-ui/icons/Print";
import MonetizationOnIcon from "@material-ui/icons/MonetizationOn";
import ReceiptIcon from "@material-ui/icons/Receipt";
import DevicesIcon from "@material-ui/icons/Devices";
import DateRangeIcon from "@material-ui/icons/DateRange";
import TodayIcon from "@material-ui/icons/Today";
import CalendarTodayIcon from "@material-ui/icons/CalendarToday";
import FilterListIcon from "@material-ui/icons/FilterList";
import CheckCircleIcon from "@material-ui/icons/CheckCircle";
import ErrorOutlineIcon from "@material-ui/icons/ErrorOutline";
import moment from "moment";
import "moment/locale/th";

import { BeamService } from "_services/beam.service";
import BeamPaymentReportPrintDialog from "./BeamPaymentReportPrintDialog";

moment.locale("th");

const useStyles = makeStyles(theme => ({
  root: {
    padding: theme.spacing(3),
    fontFamily: '"Sarabun", "Tahoma", sans-serif',
    backgroundColor: "#f8fafc",
    minHeight: "100vh"
  },
  header: {
    marginBottom: theme.spacing(3),
    display: "flex",
    alignItems: "center",
    justifyContent: "space-between",
    flexWrap: "wrap",
    gap: theme.spacing(2)
  },
  title: {
    fontWeight: "bold",
    color: "#0f172a",
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1.5),
    fontSize: "1.5rem"
  },
  filterCard: {
    marginBottom: theme.spacing(3),
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    border: "1px solid #e2e8f0"
  },
  filterHeader: {
    backgroundColor: "#ffffff",
    borderBottom: "1px solid #e2e8f0",
    padding: "16px 20px"
  },
  filterContent: {
    padding: "20px"
  },
  modeToggleGroup: {
    marginBottom: theme.spacing(2),
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(1),
    flexWrap: "wrap"
  },
  modeButton: {
    borderRadius: 20,
    textTransform: "none",
    fontWeight: 500,
    padding: "6px 16px"
  },
  activeModeButton: {
    backgroundColor: "#2563eb !important",
    color: "#ffffff !important"
  },
  summaryCard: {
    padding: theme.spacing(2.5),
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    gap: theme.spacing(2),
    boxShadow: "0 2px 6px rgba(0,0,0,0.05)",
    border: "1px solid #e2e8f0",
    backgroundColor: "#ffffff",
    height: "100%"
  },
  summaryIconBox: {
    width: 52,
    height: 52,
    borderRadius: 12,
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    flexShrink: 0
  },
  summaryTitle: {
    fontSize: "0.875rem",
    color: "#64748b",
    fontWeight: 500
  },
  summaryValue: {
    fontSize: "1.5rem",
    fontWeight: "bold",
    color: "#0f172a",
    marginTop: 2
  },
  tableCard: {
    borderRadius: 12,
    boxShadow: "0 2px 8px rgba(0,0,0,0.06)",
    border: "1px solid #e2e8f0",
    overflow: "hidden"
  },
  table: {
    minWidth: 700,
    "& th": {
      backgroundColor: "#f1f5f9",
      fontWeight: "bold",
      color: "#334155",
      fontSize: "0.9rem",
      padding: "12px 16px",
      whiteSpace: "nowrap"
    },
    "& td": {
      fontSize: "0.9rem",
      padding: "12px 16px",
      color: "#1e293b"
    },
    "& tbody tr:hover": {
      backgroundColor: "#f8fafc"
    }
  },
  searchField: {
    width: "100%",
    maxWidth: 320
  },
  statusChipPayment: {
    backgroundColor: "#dcfce7",
    color: "#166534",
    fontWeight: "bold"
  },
  statusChipRefund: {
    backgroundColor: "#ffedd5",
    color: "#9a3412",
    fontWeight: "bold"
  },
  statusChipVoid: {
    backgroundColor: "#fee2e2",
    color: "#991b1b",
    fontWeight: "bold"
  }
}));

const THAI_MONTHS = [
  { value: 1, label: "มกราคม" },
  { value: 2, label: "กุมภาพันธ์" },
  { value: 3, label: "มีนาคม" },
  { value: 4, label: "เมษายน" },
  { value: 5, label: "พฤษภาคม" },
  { value: 6, label: "มิถุนายน" },
  { value: 7, label: "กรกฎาคม" },
  { value: 8, label: "สิงหาคม" },
  { value: 9, label: "กันยายน" },
  { value: 10, label: "ตุลาคม" },
  { value: 11, label: "พฤศจิกายน" },
  { value: 12, label: "ธันวาคม" }
];

export default function BeamPaymentReportView() {
  const classes = useStyles();

  // Current User & Permission isFinance
  const currentUser = (() => {
    try {
      const u = localStorage.getItem("currentUser");
      return u ? JSON.parse(u) : null;
    } catch {
      return null;
    }
  })();

  const userDepts = (() => {
    if (!currentUser) return [];
    return Array.isArray(currentUser.userDepartment)
      ? currentUser.userDepartment
      : Array.isArray(currentUser.userView?.userDepartment)
      ? currentUser.userView.userDepartment
      : [];
  })();

  const isAdmin =
    currentUser?.roles?.includes("Admin") ||
    currentUser?.userName === "madarakung" ||
    userDepts.some(u => Number(u.departmentKey) === 108);

  const isFinance = (() => {
    if (!currentUser) return false;
    const hasSalaryDep = userDepts.some(u => Number(u.departmentKey) === 157);
    return hasSalaryDep || isAdmin;
  })();

  const currentYear = moment().year(); // ค.ศ.
  const currentMonth = moment().month() + 1; // 1-12
  const todayStr = moment().format("YYYY-MM-DD");

  // Filters State
  // filterType: 'day' | 'month' | 'range'
  const [filterType, setFilterType] = useState("day");
  const [selectedDate, setSelectedDate] = useState(todayStr);
  const [selectedMonth, setSelectedMonth] = useState(currentMonth);
  const [selectedYear, setSelectedYear] = useState(currentYear);
  const [startDate, setStartDate] = useState(moment().startOf("month").format("YYYY-MM-DD"));
  const [endDate, setEndDate] = useState(todayStr);
  const [transactionType, setTransactionType] = useState("PAYMENT");
  const [filterKioskOnly, setFilterKioskOnly] = useState(true);

  // Search inside loaded table
  const [searchTerm, setSearchTerm] = useState("");

  // Data State
  const [loading, setLoading] = useState(false);
  const [transactions, setTransactions] = useState([]);
  const [summary, setSummary] = useState({
    totalCount: 0,
    totalNetAmountBaht: 0,
    totalGrossAmountBaht: 0
  });
  const [errorMsg, setErrorMsg] = useState("");

  // Print Dialog Modal State
  const [printModalOpen, setPrintModalOpen] = useState(false);

  // Load transactions
  const fetchTransactions = async () => {
    if (!isFinance) {
      setErrorMsg("คุณไม่มีสิทธิ์เข้าถึงรายงานการชำระเงิน (ต้องมีสิทธิ์การเงิน isFinance)");
      return;
    }
    setLoading(true);
    setErrorMsg("");
    try {
      const params = {
        filterType,
        transactionType,
        filterKioskOnly,
        limit: 100
      };

      if (filterType === "day") {
        params.date = selectedDate;
      } else if (filterType === "month") {
        params.year = selectedYear;
        params.month = selectedMonth;
      } else if (filterType === "range") {
        params.startDate = startDate;
        params.endDate = endDate;
      }

      const res = await BeamService.getTransactions(params);
      if (res.data && res.data.success) {
        setTransactions(res.data.data || []);
        setSummary({
          totalCount: res.data.totalCount || 0,
          totalNetAmountBaht: res.data.totalNetAmountBaht || 0,
          totalGrossAmountBaht: res.data.totalGrossAmountBaht || 0
        });
      } else {
        setErrorMsg(res.data?.message || "ไม่สามารถดึงข้อมูลได้");
        setTransactions([]);
      }
    } catch (err) {
      console.error("Error fetching Beam transactions:", err);
      setErrorMsg(err.response?.data?.message || err.message || "เกิดข้อผิดพลาดในการเชื่อมต่อเซิร์ฟเวอร์");
      setTransactions([]);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchTransactions();
  }, [filterType, transactionType, filterKioskOnly]);

  const handleSearchSubmit = e => {
    if (e) e.preventDefault();
    fetchTransactions();
  };

  // กรองค้นหาในหน้าบ้าน (ค้นหา TransactionId, HN, FullName, ReceiptNo)
  const filteredData = transactions.filter(t => {
    if (!searchTerm.trim()) return true;
    const term = searchTerm.trim().toLowerCase();
    const id = (t.transactionId || "").toLowerCase();
    const hn = (t.hn || "").toLowerCase();
    const name = (t.fullName || "").toLowerCase();
    const receipt = (t.receiptNo || "").toLowerCase();
    return id.includes(term) || hn.includes(term) || name.includes(term) || receipt.includes(term);
  });

  const yearsOptions = [
    currentYear - 2,
    currentYear - 1,
    currentYear,
    currentYear + 1
  ];

  if (!isFinance) {
    return (
      <div className={classes.root}>
        <Card className={classes.filterCard} style={{ padding: "48px 24px", textAlign: "center", backgroundColor: "#fff" }}>
          <Box display="flex" flexDirection="column" alignItems="center" gap={2}>
            <ErrorOutlineIcon style={{ fontSize: 64, color: "#ef4444" }} />
            <Typography variant="h5" style={{ fontWeight: "bold", color: "#1e293b" }}>
              ไม่มีสิทธิ์เข้าถึงหน้ารายงานการชำระเงิน
            </Typography>
            <Typography variant="body1" style={{ color: "#64748b" }}>
              หน้ารายงานนี้สงวนสิทธิ์เฉพาะเจ้าหน้าที่ผู้มีสิทธิ์การเงิน (isFinance - แผนก 157 หรือ ผู้ดูแลระบบ) เท่านั้น
            </Typography>
          </Box>
        </Card>
      </div>
    );
  }

  return (
    <div className={classes.root}>
      {/* Header */}
      <div className={classes.header}>
        <div className={classes.title}>
          <ReceiptIcon style={{ fontSize: 32, color: "#2563eb" }} />
          <span>รายงานการชำระเงิน (BEAM Checkout)</span>
        </div>
        <Box display="flex" gap={1.5} alignItems="center">
          <Button
            variant="outlined"
            color="default"
            startIcon={<RefreshIcon />}
            onClick={fetchTransactions}
            disabled={loading}
            style={{ borderRadius: 8, backgroundColor: "#fff" }}
          >
            รีเฟรช
          </Button>
          <Button
            variant="contained"
            color="primary"
            startIcon={<PrintIcon />}
            onClick={() => setPrintModalOpen(true)}
            disabled={loading || transactions.length === 0}
            style={{ borderRadius: 8, backgroundColor: "#2563eb", color: "#fff" }}
          >
            พิมพ์รายงาน
          </Button>
        </Box>
      </div>

      {/* Filter Card */}
      <Card className={classes.filterCard}>
        <div className={classes.filterHeader}>
          <Box display="flex" alignItems="center" justifyContent="space-between" flexWrap="wrap" gap={1}>
            <Box display="flex" alignItems="center" gap={1}>
              <FilterListIcon style={{ color: "#2563eb" }} />
              <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#0f172a" }}>
                ตัวกรองข้อมูลธุรกรรม
              </Typography>
            </Box>

            {/* Filter Mode Selector Buttons */}
            <div className={classes.modeToggleGroup}>
              <Button
                size="small"
                variant={filterType === "day" ? "contained" : "outlined"}
                className={`${classes.modeButton} ${filterType === "day" ? classes.activeModeButton : ""}`}
                startIcon={<TodayIcon />}
                onClick={() => setFilterType("day")}
              >
                วันเดียว
              </Button>
              <Button
                size="small"
                variant={filterType === "month" ? "contained" : "outlined"}
                className={`${classes.modeButton} ${filterType === "month" ? classes.activeModeButton : ""}`}
                startIcon={<CalendarTodayIcon />}
                onClick={() => setFilterType("month")}
              >
                เดือนเดียว
              </Button>
              <Button
                size="small"
                variant={filterType === "range" ? "contained" : "outlined"}
                className={`${classes.modeButton} ${filterType === "range" ? classes.activeModeButton : ""}`}
                startIcon={<DateRangeIcon />}
                onClick={() => setFilterType("range")}
              >
                ช่วงวันที่ (Start - End)
              </Button>
            </div>
          </Box>
        </div>

        <CardContent className={classes.filterContent}>
          <form onSubmit={handleSearchSubmit}>
            <Grid container spacing={2} alignItems="center">
              {/* Dynamic Date Controls depending on Filter Mode */}
              {filterType === "day" && (
                <Grid item xs={12} sm={6} md={3}>
                  <TextField
                    label="เลือกวันที่"
                    type="date"
                    fullWidth
                    variant="outlined"
                    size="small"
                    value={selectedDate}
                    onChange={e => setSelectedDate(e.target.value)}
                    InputLabelProps={{ shrink: true }}
                  />
                </Grid>
              )}

              {filterType === "month" && (
                <>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      select
                      label="เดือน"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={selectedMonth}
                      onChange={e => setSelectedMonth(Number(e.target.value))}
                    >
                      {THAI_MONTHS.map(m => (
                        <MenuItem key={m.value} value={m.value}>
                          {m.label}
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      select
                      label="ปี พ.ศ. / ค.ศ."
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={selectedYear}
                      onChange={e => setSelectedYear(Number(e.target.value))}
                    >
                      {yearsOptions.map(y => (
                        <MenuItem key={y} value={y}>
                          {y + 543} ({y})
                        </MenuItem>
                      ))}
                    </TextField>
                  </Grid>
                </>
              )}

              {filterType === "range" && (
                <>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="ตั้งแต่วันที่"
                      type="date"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={startDate}
                      onChange={e => setStartDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                  <Grid item xs={12} sm={6} md={2}>
                    <TextField
                      label="ถึงวันที่"
                      type="date"
                      fullWidth
                      variant="outlined"
                      size="small"
                      value={endDate}
                      onChange={e => setEndDate(e.target.value)}
                      InputLabelProps={{ shrink: true }}
                    />
                  </Grid>
                </>
              )}

              {/* Transaction Type Filter */}
              <Grid item xs={12} sm={6} md={2}>
                <TextField
                  select
                  label="ประเภทธุรกรรม"
                  fullWidth
                  variant="outlined"
                  size="small"
                  value={transactionType}
                  onChange={e => setTransactionType(e.target.value)}
                >
                  <MenuItem value="PAYMENT">PAYMENT (ชำระเงิน)</MenuItem>
                  <MenuItem value="REFUND">REFUND (คืนเงิน)</MenuItem>
                  <MenuItem value="VOID">VOID (ยกเลิก)</MenuItem>
                  <MenuItem value="ALL">ทั้งหมด (ALL)</MenuItem>
                </TextField>
              </Grid>

              {/* Filter Kiosk Only Checkbox */}
              <Grid item xs={12} sm={6} md={3}>
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={filterKioskOnly}
                      onChange={e => setFilterKioskOnly(e.target.checked)}
                      color="primary"
                    />
                  }
                  label={
                    <Box display="flex" alignItems="center" gap={0.5}>
                      <DevicesIcon style={{ fontSize: 20, color: "#475569" }} />
                      <Typography variant="body2" style={{ fontWeight: 500 }}>
                        เฉพาะ Kiosk (type=Kiosk)
                      </Typography>
                    </Box>
                  }
                />
              </Grid>

              {/* Submit Button */}
              <Grid item xs={12} sm={6} md={2}>
                <Button
                  type="submit"
                  fullWidth
                  variant="contained"
                  color="primary"
                  startIcon={loading ? <CircularProgress size={18} color="inherit" /> : <SearchIcon />}
                  disabled={loading}
                  style={{
                    backgroundColor: "#2563eb",
                    color: "#fff",
                    height: 40,
                    borderRadius: 8,
                    fontWeight: "bold"
                  }}
                >
                  ค้นหา
                </Button>
              </Grid>
            </Grid>
          </form>
        </CardContent>
      </Card>

      {/* Summary Stat Cards */}
      <Grid container spacing={3} style={{ marginBottom: 24 }}>
        <Grid item xs={12} sm={4}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#eff6ff", color: "#2563eb" }}>
              <ReceiptIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>จำนวนธุรกรรมทั้งหมด</div>
              <div className={classes.summaryValue}>
                {summary.totalCount.toLocaleString()} <span style={{ fontSize: "1rem", fontWeight: "normal", color: "#64748b" }}>รายการ</span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#ecfdf5", color: "#16a34a" }}>
              <MonetizationOnIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>ยอดเงินสุทธิรวม (บาท)</div>
              <div className={classes.summaryValue} style={{ color: "#16a34a" }}>
                {Number(summary.totalNetAmountBaht || 0).toLocaleString("th-TH", {
                  minimumFractionDigits: 2,
                  maximumFractionDigits: 2
                })} <span style={{ fontSize: "1rem", fontWeight: "normal", color: "#64748b" }}>บาท</span>
              </div>
            </div>
          </div>
        </Grid>

        <Grid item xs={12} sm={4}>
          <div className={classes.summaryCard}>
            <div className={classes.summaryIconBox} style={{ backgroundColor: "#faf5ff", color: "#9333ea" }}>
              <DevicesIcon style={{ fontSize: 28 }} />
            </div>
            <div>
              <div className={classes.summaryTitle}>แหล่งที่มาและประเภท</div>
              <div style={{ marginTop: 4, display: "flex", gap: 6, flexWrap: "wrap" }}>
                <Chip
                  size="small"
                  label={filterKioskOnly ? "เฉพาะ Kiosk" : "ทุกแหล่งที่มา"}
                  style={{ backgroundColor: "#ede9fe", color: "#6b21a8", fontWeight: "bold" }}
                />
                <Chip
                  size="small"
                  label={`ประเภท: ${transactionType}`}
                  style={{ backgroundColor: "#e0f2fe", color: "#0369a1", fontWeight: "bold" }}
                />
              </div>
            </div>
          </div>
        </Grid>
      </Grid>

      {/* Error Message */}
      {errorMsg && (
        <Box
          display="flex"
          alignItems="center"
          gap={1.5}
          p={2}
          mb={3}
          style={{
            backgroundColor: "#fef2f2",
            border: "1px solid #fecaca",
            borderRadius: 8,
            color: "#b91c1c"
          }}
        >
          <ErrorOutlineIcon />
          <Typography variant="body2">{errorMsg}</Typography>
        </Box>
      )}

      {/* Table Card */}
      <Card className={classes.tableCard}>
        <Box
          p={2}
          display="flex"
          alignItems="center"
          justifyContent="space-between"
          flexWrap="wrap"
          gap={2}
          style={{ borderBottom: "1px solid #e2e8f0" }}
        >
          <Typography variant="subtitle1" style={{ fontWeight: "bold", color: "#0f172a" }}>
            รายการธุรกรรม ({filteredData.length} รายการ)
          </Typography>
          <TextField
            size="small"
            variant="outlined"
            placeholder="ค้นหา Transaction ID, HN, ชื่อผู้ป่วย หรือเลขที่ใบเสร็จ..."
            value={searchTerm}
            onChange={e => setSearchTerm(e.target.value)}
            className={classes.searchField}
            style={{ maxWidth: 360 }}
            InputProps={{
              startAdornment: (
                <InputAdornment position="start">
                  <SearchIcon style={{ color: "#94a3b8" }} />
                </InputAdornment>
              )
            }}
          />
        </Box>

        <TableContainer component={Paper} elevation={0}>
          <Table className={classes.table}>
            <TableHead>
              <TableRow>
                <TableCell style={{ width: 50, textAlign: "center" }}>ลำดับ</TableCell>
                <TableCell style={{ minWidth: 150 }}>Transaction ID</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 90 }}>HN (Kiosk)</TableCell>
                <TableCell style={{ minWidth: 160 }}>ชื่อ - สกุล</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 110 }}>เลขที่ใบเสร็จ</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 90 }}>ประเภท</TableCell>
                <TableCell style={{ textAlign: "center", minWidth: 140 }}>วัน-เวลาที่ทำรายการ</TableCell>
                <TableCell style={{ textAlign: "right", minWidth: 110 }}>ยอดสุทธิ (บาท)</TableCell>
              </TableRow>
            </TableHead>
            <TableBody>
              {loading ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center", padding: "40px 0" }}>
                    <CircularProgress size={32} />
                    <Typography variant="body2" style={{ color: "#64748b", marginTop: 8 }}>
                      กำลังดึงข้อมูลธุรกรรมจาก BEAM และจับคู่กับฐานข้อมูล Softcon...
                    </Typography>
                  </TableCell>
                </TableRow>
              ) : filteredData.length === 0 ? (
                <TableRow>
                  <TableCell colSpan={8} style={{ textAlign: "center", padding: "40px 0", color: "#64748b" }}>
                    ไม่พบข้อมูลธุรกรรมตามเงื่อนไขที่ระบุ
                  </TableCell>
                </TableRow>
              ) : (
                filteredData.map((row, index) => {
                  const typeUpper = (row.transactionType || "").toUpperCase();
                  const chipClass =
                    typeUpper === "PAYMENT"
                      ? classes.statusChipPayment
                      : typeUpper === "REFUND"
                      ? classes.statusChipRefund
                      : classes.statusChipVoid;

                  return (
                    <TableRow key={row.transactionId || index}>
                      <TableCell style={{ textAlign: "center", color: "#64748b" }}>
                        {index + 1}
                      </TableCell>
                      <TableCell style={{ fontFamily: "monospace", fontWeight: 500 }}>
                        {row.transactionId}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", fontWeight: "bold", color: "#1e293b" }}>
                        {row.hn ? (
                          <Chip size="small" label={row.hn} style={{ backgroundColor: "#e2e8f0", fontWeight: "bold" }} />
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </TableCell>
                      <TableCell style={{ fontWeight: 500, color: "#0f172a" }}>
                        {row.fullName || <span style={{ color: "#94a3b8" }}>-</span>}
                      </TableCell>
                      <TableCell style={{ textAlign: "center", fontWeight: 500, color: "#1e293b" }}>
                        {row.receiptNo ? (
                          <Chip size="small" variant="outlined" label={row.receiptNo} style={{ borderColor: "#cbd5e1" }} />
                        ) : (
                          <span style={{ color: "#94a3b8" }}>-</span>
                        )}
                      </TableCell>
                      <TableCell style={{ textAlign: "center" }}>
                        <Chip size="small" label={row.transactionType} className={chipClass} />
                      </TableCell>
                      <TableCell style={{ textAlign: "center", color: "#334155" }}>
                        {row.transactionTimeFormatted || moment(row.transactionTime).format("DD/MM/YYYY HH:mm:ss")}
                      </TableCell>
                      <TableCell style={{ textAlign: "right", fontWeight: "bold", color: "#0f172a" }}>
                        {Number(row.netAmountBaht || 0).toLocaleString("th-TH", {
                          minimumFractionDigits: 2,
                          maximumFractionDigits: 2
                        })}
                      </TableCell>
                    </TableRow>
                  );
                })
              )}
              {filteredData.length > 0 && (
                <TableRow style={{ backgroundColor: "#f8fafc", fontWeight: "bold" }}>
                  <TableCell colSpan={7} style={{ textAlign: "right", fontWeight: "bold", fontSize: "0.95rem" }}>
                    รวมทั้งสิ้น ({filteredData.length} รายการ):
                  </TableCell>
                  <TableCell style={{ textAlign: "right", fontWeight: "bold", color: "#16a34a", fontSize: "1rem" }}>
                    {filteredData.reduce((acc, curr) => acc + Number(curr.netAmountBaht || 0), 0).toLocaleString("th-TH", {
                      minimumFractionDigits: 2,
                      maximumFractionDigits: 2
                    })}
                  </TableCell>
                </TableRow>
              )}
            </TableBody>
          </Table>
        </TableContainer>
      </Card>

      {/* Print Preview Modal Dialog */}
      <BeamPaymentReportPrintDialog
        open={printModalOpen}
        onClose={() => setPrintModalOpen(false)}
        data={filteredData}
        filter={{
          filterType,
          date: selectedDate,
          month: selectedMonth,
          year: selectedYear,
          startDate,
          endDate,
          transactionType,
          filterKioskOnly
        }}
        summary={summary}
        currentUser={currentUser}
      />
    </div>
  );
}

